<template>
  <div class="ment-item" :style="{fontSize:fontSize+'px',color:fontColor}">
    <el-submenu popper-class="navmenu-popper-box" v-for="item,i of items" :key="i" :index="getIndex(item.id,item)" v-if="type==1" :popper-append-to-body="true">
      <!-- {{pid?pid+'-'+item.id:item.id}} -->
      <template slot="title">
        <i :style="{fontSize:pid?(Number(fontSize)-1)+'px':fontSize+'px',color:fontColor}">{{item.controlName}}</i>
      </template>
      <menuItem @changeBlock="changeBlock($event,item)" :opacity="opacity" :fontSize="fontSize" :fontColor="fontColor" :activedBgColor="activedBgColor" :activeOpacity="activeOpacity" :menuData="[item]" :isPanel='true' :pid="pid?pid+'-'+item.id:item.id"></menuItem>
    </el-submenu>
    <div v-for="item,i of items" :key="i" v-if="type==2">
      <el-menu-item :style="{fontSize:pid?(Number(fontSize)-1)+'px':fontSize+'px'}" :index="getIndex(item.value,item)" v-if="!childrenData['state'+item.value]" @click="change(pid?pid+'-'+item.value:item.value,item)">
        <div class="active-bg" :style="{backgroundColor:getRgba(activedBgColor,activeOpacity)}">{{item.name}}</div>
      </el-menu-item>
      <el-submenu popper-class="navmenu-popper-box" :index="getIndex(item.value,item)" v-if="childrenData['state'+item.value]" :popper-append-to-body="true">
        <template slot="title"><i :style="{fontSize:pid?(Number(fontSize)-1)+'px':fontSize+'px'}">{{item.name}}</i>  <!-- {{pid?pid+'-'+item.value:item.value}}  --></template>
        <menuItem @changeBlock="changeBlock($event,item)" :opacity="opacity" :fontSize="fontSize" :fontColor="fontColor" :activedBgColor="activedBgColor" :activeOpacity="activeOpacity" :menuData="childrenData['state'+item.value+'Panels']" :isPanel='true' :pid="pid?pid+'-'+item.value:item.value"></menuItem>
      </el-submenu>
    </div>
  </div>
</template>

<script>
// import { Panel } from 'vant'

  export default{
    name: "menuItem",
    props: {
      menuData: {
        default: [],
        type: Array
      },
      fontSize: {
        type: [String,Number]
      },
      fontColor: {
        type: String
      },
      activedBgColor:{
        default: "f0f0f0",
        type: String
      },
      activeOpacity:{
        default: 100,
        type: [String,Number]
      },
      opacity: {
        default: 100,
        type: [String,Number]
      },
      isTop: {
        default: false,
        type: Boolean
      },
      isPanel: {
        default: false,
        type: Boolean
      },
      pid: {
        default: "",
        type: [String,Number]
      },
    },
    computed:{
      getIndex(){
        return (index,item)=>{
          if(this.pid){
            return this.pid+'-'+index
          }else{
            if(!index){
              console.log(item)
            }else{
              return index.toString()
            }
          }
        }
      },
      getRgba() {
        return (rgb, a) => {
          if(rgb=='#fff'){
            rgb='#ffffff'
          }
          if (rgb == 'transparent' || a == 100) {
            return rgb
          } else if (a == 0) {
            return 'transparent !important'
          } else {
            a = parseInt(a * 2.55)
            a = a.toString(16)
            return rgb + a
          }
        }
      }
    },
    created() {
      // console.log(this.pid)
      if(this.isTop&&this.menuData.length==1||this.isPanel&&this.menuData.length==1){
        var items=this.menuData[0].blockList
        let blockContentList = this.menuData[0].blockContentList
        // 获取子级控件含有面板的数量
        for(let item of items){
          // 获取对应状态页
          // console.log(item)
          let drags = blockContentList.find(drag =>drag.id==item.value)
          if(drags){
            let panels = drags.drags.filter(panel=>panel.type=='panel'&&panel.deleted != true)
            this.$set(this.childrenData,'state'+item.value,panels.length)
            if(panels.length){
              this.$set(this.childrenData,'state'+item.value+'Panels',panels)
            }
          }else{
            this.$set(this.childrenData,'state'+item.value,0)
          }
        }
        this.items = items
        this.type = 2
      }else{
        this.items=this.menuData
      }
    },
    data(){
      return {
        items:[],
        type:1,
        childrenData:{},
      }
    },
    methods:{
      change(pid,item){
        // console.log(pid,item)
        // this.$emit("changeBlock",{type:this.type,key:this.type==2?item.value:item.id})
      },
      changeBlock(e,item){
        if(e.type==2){
          item.activeBlock=e.key
          if(this.$parent){
            this.$emit("changeBlock",{type:this.type,key:this.type==2?item.value:item.id})
          }
        }else if(e.type==1){
          console.log(this.childrenData)
        }
      },
    },
  }
</script>

<style style="scss" scoped>
  .ment-item:focus,.active-bg:focus{
    outline:none;
  }
  .active-bg{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    padding: 0 20px ;
    padding-left: inherit;
    box-sizing: border-box;
  }
  /* .p-l-40>.el-menu-item>.active-bg{
    padding-left: 40px;
  } */
</style>



// WEBPACK FOOTER //
// src/pages/Editor/menuItem.vue